import { useMemo } from "react";
import {
  groupClipVersions,
  type ClipWithVersion,
  type ClipVersionGroups,
} from "@/lib/clips/groupClipVersions";

export type { VersionGroup } from "@/lib/clips/groupClipVersions";

/**
 * Groups clips by version chain (see groupClipVersions in src/lib/clips).
 * Clips with the same source_clip_id (or that ARE the source) are grouped together.
 */
export function useClipVersionGroups<T extends ClipWithVersion>(clips: T[]): ClipVersionGroups<T> {
  return useMemo(() => groupClipVersions(clips), [clips]);
}
